import { render, staticRenderFns } from "./FaqComponent.vue?vue&type=template&id=03da8bc8"
import script from "./FaqComponent.vue?vue&type=script&lang=js"
export * from "./FaqComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03da8bc8')) {
      api.createRecord('03da8bc8', component.options)
    } else {
      api.reload('03da8bc8', component.options)
    }
    module.hot.accept("./FaqComponent.vue?vue&type=template&id=03da8bc8", function () {
      api.rerender('03da8bc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/customer/FaqComponent.vue"
export default component.exports